import { TYPE_DOCUMENT } from './enums';

const CpfMask = (value: string): string => {
  return value?.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
};

const CnpjMask = (value: string): string => {
  return value?.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
    '$1.$2.$3/$4-$5',
  );
};

const CreditCardMask = (value: string): string => {
  return value?.replace(
    /^(\d{4})(\d{4})(\d{4})(\d{4})/,
    '$1 $2 $3 $4',
  );
};

const RgMask = (value: string): string => {
  return value?.replace(/(\d{2})(\d{3})(\d{3})(\d{1})/, '$1.$2.$3-$4');
};

export const formatDocument = (document: string, type: string): string => {
  if (!document) return document;
  const replaceValue = document.replace(/\D/g, '');

  const maskDocument: Record<string, string> = {
    [TYPE_DOCUMENT.RG]: RgMask(replaceValue),
    [TYPE_DOCUMENT.CPF]: CpfMask(replaceValue),
    [TYPE_DOCUMENT.CNPJ]: CnpjMask(replaceValue),
    [TYPE_DOCUMENT.CREDITCARD]: CreditCardMask(replaceValue),
  };

  const key: string = type;

  return maskDocument[key];
};
